import './health-provider-translation-list-item.scss';

import { useMemo } from 'react';

import {
  HealthProviderTranslationItemDataFragment,
  TranslationType,
} from '../../../data/types/api/graphql';
import { makeKeyDownHandler } from '../../../data/utils/make-key-down-handler';
import { CustomFormattedMessage } from '../../../elements/intl/custom-formatted-message';
import { Tag, TagType } from '../../../elements/tag/tag';

type HealthProviderTranslationListItemProps = {
  translation: HealthProviderTranslationItemDataFragment;
  onClick?: (value: HealthProviderTranslationItemDataFragment) => void;
};

export function HealthProviderTranslationListItem({
  onClick,
  translation,
}: HealthProviderTranslationListItemProps) {
  const attributes = useMemo(() => {
    if (onClick) {
      return {
        role: 'button',
        tabIndex: 0,
        onClick: () => onClick(translation),
        onKeyDown: makeKeyDownHandler(() => onClick(translation)),
      };
    }

    return {};
  }, [translation, onClick]);

  return (
    <div
      {...attributes}
      className={`health-provider-translation-list-item ${`health-provider-translation-list-item${
        translation.filled ? '--active' : '--notactive'
      }`}`}
    >
      <div className="health-provider-translation-list-item__tags">
        {translation.type === TranslationType.App && <Tag type={TagType.APP} />}
        {translation.type === TranslationType.Server && (
          <Tag type={TagType.SERVER} />
        )}
        {translation.type === TranslationType.Portal && (
          <Tag type={TagType.PORTAL} />
        )}
      </div>

      <div className="health-provider-translation-list-item__content">
        <h3>{translation.info}</h3>

        <p className={translation.filled ? 'active' : ''}>
          <CustomFormattedMessage
            id={translation.filled ? 'common.changed' : 'common.default'}
          />
        </p>
      </div>
      <div className="health-provider-translation-list-item__key">
        {translation.key}
      </div>
    </div>
  );
}
